// extracted by mini-css-extract-plugin
export default {"provider-description-field":"DescriptionForm_provider-description-field__FFvOI"};